import React, { useEffect, useState, useMemo, useRef } from 'react'
import styled from 'styled-components'
import { XDivider, YDivider, FlexByRowCentered, useTheme } from 'irmlib/styles'
import { ThemeButton, ContainedButton } from 'irmlib/components/Controls'
import { CancelButton } from 'irmlib/components/FormControls'
import * as routePaths from '../../../navigation/routePaths'
import { useLocation, useHistory } from 'react-router-dom'
import { openGeneralDialog, closeGeneralDialog, LocalToast } from 'irmlib/containers'
import * as gdeTransactionsLite from '../../../services/firestore/gdeTransactionsLite'
import * as constants from 'irmlib/common/constants'
import { MaterialReactTable } from 'material-react-table'
import PropTypes from 'prop-types'
// import { useMergeState, useConstructor } from '../../../irmlib/src/hooks'
// import MaterialTable from 'material-table'
// import ChevronLeft from '@material-ui/icons/ChevronLeft'
// import ChevronRight from '@material-ui/icons/ChevronRight'
// import FirstPage from '@material-ui/icons/FirstPage'
// import LastPage from '@material-ui/icons/LastPage'
// import ViewColumn from '@material-ui/icons/ViewColumn'
// import FilterList from '@material-ui/icons/FilterList'
// import ArrowDownward from '@material-ui/icons/ArrowDownward'
// import cloneDeep from 'clone-deep'
// import { useConstructor } from 'irmlib/hooks'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import { useTranslation } from 'react-i18next'
import { errorToast } from '../../../common/functions'

const VerticalDivider = () => <YDivider height="30px" />

const BottomPaddedButton = (props) => (
  <>
    <ThemeButton {...props} />
    <VerticalDivider />
  </>
)

const BottomPaddedDiv = styled('div')`
  padding-bottom: 20px;
`

const TableContainer = styled(BottomPaddedDiv)`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
`

// const initialSate = {
//   showTable: false,
//   boxes: [],
//   jobDoc: '',
//   selectedBoxes: [],
//   userData: [],
//   isApproved: false
// }

const BoxesTable = (props) => {
  const { t } = useTranslation()
  const theme = useTheme()
  // const [state, setState] = useMergeState(initialSate)
  // const { boxes } = state
  // const [changeApprove, setChangeApprove] = useState(true)
  const [refresh, setRefresh] = useState(false)
  const {
    columnsList,
    jobId: jobIdProp,
    boxList: boxListProp = [],
    isLoading = false,
    onApproveComplete,
  } = props
  // const [boxList, setBoxList] = useState([])
  const location = useLocation()
  const jobId = jobIdProp ?? location.pathname.split('/')[2]
  const pathParams = location.pathname.split('/')
  const isBoxList = pathParams[1]
  // const refFileList = useRef(null)
  const refLocalToast = useRef(null)
  const history = useHistory()
  const [rowSelection, setRowSelection] = useState({})

  // useEffect(() => {
  //   setBoxList(props.boxList)
  // }, [props.boxList])
  
  // // backend data conversion for box status
  // boxList.forEach((element, index) => {
  //   element.status = t(`boxStatusObj.${element.status1}`)
  // })
  
  // useConstructor(() => {
  //   refFileList.current = cloneDeep(props.boxList)
  // })

  useEffect(() => {
    setRowSelection({})
  }, [refresh])

  useEffect(() => {
    setRowSelection((prev) => {
      if (!Object.keys(prev).length) {
        return prev
      }
      const validIds = new Set(boxListProp.map((row) => row.skpBoxId))
      const next = {}
      Object.keys(prev).forEach((id) => {
        if (validIds.has(id) && prev[id]) {
          next[id] = true
        }
      })
      return next
    })
  }, [boxListProp])

  const tableData = useMemo(() => boxListProp.map((row) => ({
    ...row,
    status: t(`boxStatusObj.${row.status1}`),
  })), [boxListProp, t])

  const selectedBoxRows = useMemo(
    () => boxListProp.filter((row) => rowSelection[row.skpBoxId]),
    [boxListProp, rowSelection],
  )

  const tableState = useMemo(() => ({
    rowSelection,
    isLoading,
  }), [rowSelection, isLoading])

  const approveDisabled = selectedBoxRows.length === 0

  const ButtonsForApprove = ({ onConfirm }) =>
    <>
      <CancelButton onClick={closeGeneralDialog} noTranslate={true} />
      <XDivider width='10px' />
      <ContainedButton
        id="approveComponent"
        onClick={onConfirm}
        noTranslate={true}
      >
        {t('buttons.approve')}
      </ContainedButton>
    </>

  ButtonsForApprove.propTypes = {
    onConfirm: PropTypes.func,
  }

  const openApproveModal = async () => {
    const boxesToApprove = [...selectedBoxRows]
    if (!boxesToApprove.length) {
      return
    }
    try {
      const jobDetails = await gdeTransactions.getJobById(jobId)
      const jobData = jobDetails.data()
      const isAutoTransmit = jobData.autoTransmit === undefined || jobData.autoTransmit === 'true'
      openGeneralDialog({
        title: t('qualityCheck.approveTransmit'),
        message: isAutoTransmit
          ? t('qualityCheck.approveBoxesMsgForautoTransmit')
          : t('qualityCheck.approveBoxesMsgForManualTransmit'),
        buttons: <ButtonsForApprove onConfirm={() => approveBoxes(jobData, boxesToApprove)} />,
        translateMessage: false,
        noTranslateTitle: true,
        closeX: true,
      })
    } catch (err) {
      errorToast({ message: err?.message, title: t('toast.error') })
    }
  }

  const statusUpdateForJob = async (jobDetail) => {
    const collection = await gdeTransactionsLite.getBoxesForJob(jobId)
    const boxListLocal = []

    collection.forEach((doc) => {
      const data = doc.data()
      boxListLocal.push({
        boxId: data.boxId,
        entryUser: data.dataEntryUser,
        status: data.status,
        dataEntryUser: data.dataEntryUser,
        verificationUser: data.verificationUser
      })
    })
    const checkReadyToTransmit = (Boxes) => {
      if (Boxes.status === constants.boxStatus.approved) {
        return Boxes.status === constants.boxStatus.approved
      }
      if (Boxes.status === constants.boxStatus.transmitted) {
        return Boxes.status === constants.boxStatus.transmitted
      }
      if (Boxes.status === constants.boxStatus.exception) {
        return Boxes.status === constants.boxStatus.exception
      }
    }

    const result = boxListLocal.filter(checkReadyToTransmit)

    const transmitBoxEqual = boxListLocal.length === 0 ? false : boxListLocal.length === result.length

    if (transmitBoxEqual && jobDetail.totalBoxes !== 9999) {
      const data = {
        jobStatus: constants.jobStatus.readyToTransmit,
        autoTransmitAndStatus: `${jobDetail.autoTransmit}-${constants.jobStatus.readyToTransmit}`,
      }
      await gdeTransactions.updateJob(jobId, data)
    }
  }

  const approveBoxes = async (jobDetails, boxesToApprove) => {
    if (!boxesToApprove?.length) {
      return
    }
    try {
      await gdeTransactionsLite.updateBoxStatus(
        jobId,
        '',
        constants.boxStatus.approved,
        true,
        boxesToApprove,
      )
      await statusUpdateForJob(jobDetails)
      closeGeneralDialog()
      setRefresh((flag) => !flag)
      onApproveComplete?.()
      const approvedAll =
        boxListProp.length > 0 && boxesToApprove.length >= boxListProp.length
      if (boxListProp.length === 1 || approvedAll) {
        history.push(routePaths.qualityCheck)
      }
    } catch (err) {
      errorToast({ message: err?.message, title: t('toast.error') })
    }
  }

  const onClickCancel = async () => {
    // history.goBack()
    history.push(routePaths.qualityCheck)
  }

  // const onSelectionChange = async (rows) => {
  //   if (rows.length > 0) {
  //     setChangeApprove(false)
  //   } else {
  //     setChangeApprove(true)
  //   }
  //   setState({ selectedBoxes: rows })
  // }

  // const tableIcons = {
  //   FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  //   LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  //   NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  //   PreviousPage: forwardRef((props, ref) => (
  //     <ChevronLeft {...props} ref={ref} />
  //   )),
  //   ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  //   SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  //   Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  // }

  return (
    <>
      <LocalToast ref={refLocalToast} />

      <TableContainer>
        <MaterialReactTable
          columns={columnsList}
          data={tableData}
          getRowId={(row) => row.skpBoxId}
          enableStickyHeader
          enableRowVirtualization
          enableRowSelection
          onRowSelectionChange={setRowSelection}
          state={tableState}
          defaultColumn={{
            minSize: 72,
            grow: 1,
            enableColumnFilter: true,
            filterVariant: 'text',
          }}
          enableColumnActions
          enableColumnResizing
          enableDensityToggle
          enableFullScreenToggle={false}
          enableHiding
          enableSorting
          enableGlobalFilter
          enableColumnFilters
          enableFilterMatchHighlighting
          positionToolbarAlertBanner="none"
          initialState={{
            density: 'compact',
            pagination: { pageSize: 25, pageIndex: 0 },
            sorting: [{ id: 'skpBoxId', desc: false }],
            showGlobalFilter: true,
          }}
          muiSearchTextFieldProps={{
            placeholder: t('routeTitles.boxQcTableSearchPlaceholder'),
            sx: { minWidth: 'min(100%, 280px)' },
            variant: 'outlined',
            size: 'small',
          }}
          muiTopToolbarProps={{
            sx: {
              flexWrap: 'wrap',
              gap: 1,
              py: 1,
              px: 1,
              maxWidth: '100%',
              overflowX: 'hidden',
              '& .MuiTextField-root': { maxWidth: 'min(100%, 320px)' },
            },
          }}
          muiTablePaperProps={{
            elevation: 1,
            sx: { width: '100%', maxWidth: '100%', overflow: 'hidden' },
          }}
          muiTableContainerProps={{
            sx: {
              maxHeight: 'min(70vh, 640px)',
              width: '100%',
              maxWidth: '100%',
              overflowY: 'auto',
              overflowX: 'hidden',
            },
          }}
          muiTableProps={{
            sx: { width: '100%', tableLayout: 'fixed' },
          }}
          muiTableHeadCellProps={{
            sx: {
              fontWeight: 700,
              backgroundColor: theme.palette?.grey?.[50] || '#f5f5f5',
              color: theme.palette?.text?.primary,
              zIndex: 2,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
          }}
          muiTableBodyCellProps={{
            sx: {
              color: theme.palette?.text?.primary,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              verticalAlign: 'middle',
            },
          }}
          muiTableBodyRowProps={() => ({
            sx: {
              '&:nth-of-type(odd)': { backgroundColor: theme.palette?.grey?.[50] || '#fafafa' },
            },
          })}
        />
      </TableContainer>
      <FlexByRowCentered
      >
        <>
          <CancelButton onClick={onClickCancel} noTranslate={true} label={t('buttons.cancel')}/>
          <XDivider width="20px" />
          {isBoxList === 'boxQualityCheck'
            ? <BottomPaddedButton id={'dataEntry_button_select_fieldstoupdate'} variant='contained' color='primary' onClick={openApproveModal} disabled={approveDisabled} noTranslate={true}>
              {t('buttons.approve')}
            </BottomPaddedButton>
            : null}
          <XDivider width="20px" />

        </>

      </FlexByRowCentered>
    </>
  )
}
BoxesTable.propTypes = {
  columnsList: PropTypes.array,
  boxList: PropTypes.array,
  jobId: PropTypes.string,
  isLoading: PropTypes.bool,
  onApproveComplete: PropTypes.func,
}

export default BoxesTable